import { Document, ProcessingStatus } from '@/types/Document';

interface DashboardKPICardsProps {
  documents: Document[];
  processingStatuses: Record<string, ProcessingStatus>;
}

export default function DashboardKPICards({ documents, processingStatuses }: DashboardKPICardsProps) {
  const processedCount = documents.filter(doc => processingStatuses[doc.id] === 'done').length;
  const errorCount = documents.filter(doc => processingStatuses[doc.id] === 'error').length;

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
      {/* Total Documents Card */}
      <div className="bg-white rounded-lg shadow border border-gray-200 p-6">
        <div className="flex justify-between items-start">
          <div>
            <h2 className="text-lg font-medium text-gray-900">Total Documents</h2>
            <p className="text-4xl font-bold mt-4">{documents.length}</p>
            <p className="text-gray-600 mt-1">Documents added</p>
          </div>
          <div className="bg-gray-100 p-3 rounded-md">
            <svg className="h-6 w-6 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
            </svg>
          </div>
        </div>
      </div>
      
      {/* Successfully Processed Card */}
      <div className="bg-white rounded-lg shadow border border-gray-200 p-6">
        <div className="flex justify-between items-start">
          <div>
            <h2 className="text-lg font-medium text-gray-900">Successfully Processed</h2>
            <p className="text-4xl font-bold mt-4">{processedCount}</p>
            <p className="text-gray-600 mt-1">Documents processed</p>
          </div>
          <div className="bg-green-100 p-3 rounded-md">
            <svg className="h-6 w-6 text-green-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
            </svg>
          </div>
        </div>
      </div>
      
      {/* Errors Card */}
      <div className="bg-white rounded-lg shadow border border-gray-200 p-6">
        <div className="flex justify-between items-start">
          <div>
            <h2 className="text-lg font-medium text-gray-900">Errors</h2>
            <p className="text-4xl font-bold mt-4">{errorCount}</p>
            <p className="text-gray-600 mt-1">Processing failures</p>
          </div>
          <div className="bg-red-100 p-3 rounded-md">
            <svg className="h-6 w-6 text-red-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
          </div>
        </div>
      </div>
    </div>
  );
}
